module.exports = __webpack_public_path__ + "img/exp__3.54d8a073.jpg";